import React from 'react';
import InlineNotice from './InlineNotice';

/**
 * InlineError — alias fino de `<InlineNotice variant="danger">`.
 *
 * <p>Preservado por conveniência: os 47 callers migrados na Fase B já
 * importam `InlineError` e o nome comunica intent (é o caso mais comum).
 * Semanticamente equivalente a `<InlineNotice variant="danger" ...>`.
 *
 * <p>Contrato de props idêntico ao InlineNotice (menos `variant`): `title`,
 * `cause`, `dismissible`, `onDismiss`.
 *
 * <p>Se precisar success/warn/info dentro de modal, use InlineNotice
 * diretamente com a variant apropriada (REDLINE-feedback §5).
 */
export default function InlineError(props) {
	return <InlineNotice variant="danger" {...props} />;
}
